import Api from '@/api/api'

export default {
  profile() {
    return Api().get('user/profile')
  },
  dashboard() {
    return Api().get('user/dashboard')
  },
  accountSummary() {
    return Api().get('account-summary')
  },
  incomeStore(data) {
    return Api().post('online-income/store', data)
  },
  expenses() {
    return Api().get('expense')
  },
}
